import React, { useState, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import Tab from "@mui/material/Tab";
import { TabList, TabPanel, TabContext } from "@mui/lab";
import "./index.css";
import Card from "../dashboard/card/Card";
import Loading from "../loading/Loading";
import NoData from "../noData/NoData";
import AddOrder_svg from "../../svg/svg-body/AddOrder_svg";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import FilterModal from "./component/FilterModal";
import { StoreContext } from "../../store";
import { StoreContext as OldStoreContext } from "../../../store/Provider";
import { path } from "../../constants/apiPath";
import instance from "../../common/api/interceptor";
import { NotificationManager } from "react-notifications";
import { Outlet, useNavigate } from "react-router-dom";
// import routeConstant from "../../routes/utils/routeConstant";
import moment from "moment";
import { LOCAL_STORAGE_KEY } from "../../../config";
import routeConstant from "../../../route/compoent/routeConstant";
import { OrderContext } from "./store";
import { userRole } from "../../utils/utility";
import { TextField, Autocomplete } from "@mui/material";

function OrderList() {
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const context = useContext(StoreContext);
  const oldContext = useContext(OldStoreContext);
  const [search, setSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchCards, setSearchCards] = useState({});
  const [comment, setComment] = useState("");
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [buyerList, setBuyerList] = useState([]);
  const [buyerSelected, setBuyerSelected] = useState({
    OrgCode: "",
    OrgName: "",
  });
  const pageSize = 10000;
  const location = useLocation();
  const navigate = useNavigate();

  const {
    placedData,
    setPlacedData,
    orderDetails,
    setOrderDetails,
    approvedData,
    setApprovedData,
    shippedData,
    setShippedData,
    rejectedData,
    setRejectedData,
    archiveData,
    setArchiveData,
  } = useContext(OrderContext);

  console.log(context?.userAccess, "Permission in OrderList");

  useEffect(() => {
    getBuyerList();
    setOrderDetails({});
    if (location.pathname.includes("placed")) {
      setValue(0);
    } else if (location.pathname.includes("approved")) {
      setValue(1);
    } else if (location.pathname.includes("loaded")) {
      setValue(2);
    } else if (location.pathname.includes("cancelled")) {
      setValue(3);
    } else if (location.pathname.includes("archived")) {
      setValue(4);
    }
  }, [location.pathname]);

  const orderDetailsCardClick = async (ele) => {
    setComment("");
    if (ele?.OrderPK !== orderDetails?.OrderHeader?.OrderPK) {
      context.setBackDropOpen(true);
      await instance
        .get(`${path.GET_ORDER_DETAIL}?orderPk=${ele.OrderPK}`)
        .then(async (res) => {
          context.setBackDropOpen(false);

          if (res.Is_Success) {
            setOrderDetails(res.data ?? {});
            getComments(ele.OrderPK);
          } else {
            NotificationManager.error(res.Message, "", 3000);
            setOrderDetails({});
          }
        })
        .catch((err) => {
          context.setBackDropOpen(false);

          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setOrderDetails({});
        });
    }
  };

  const getBuyerList = () => {
    instance
      .get(`${path.GET_BUYER_SUPPIER}?code=Buyer`)
      .then((res) => {
        setBuyerList(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const removeOrder = (arr, orderPk) => {
    // console.log("placedOrder", arr, orderDetails.OrderHeader.OrderPK, arr[0].OrderPK)
    const order = arr.filter((ele) => ele.OrderPK !== orderPk);
    return order;
  };

  const emptyData = (status) => {
    switch (status) {
      case "PLC":
        setPlacedData({ ...placedData, data: [], page: 0, hasMore: false });
        break;
      case "APP":
        setApprovedData({ ...approvedData, data: [], page: 0, hasMore: false });
        break;
      case "SHP":
        setShippedData({ ...shippedData, data: [], page: 0, hasMore: false });
        break;
      case "CAN":
        setRejectedData({ ...rejectedData, data: [], page: 0, hasMore: false });
        break;
      case "ARC":
        setArchiveData({ ...archiveData, data: [], page: 0, hasMore: false });
        break;
    }
  };

  const onOrderStatusChange = async (orderPk, orderStatus) => {
    context.setBackDropOpen(true);
    const userstatus = oldContext.omsUserData.UserRoles;
    instance
      .post(
        `${path.CHANGE_ORDER_STATUS}?orederPk=${orderPk}&status=${orderStatus}&roles=${userstatus}`
      )
      .then(async (res) => {
        if (res.Is_Success) {
          setOrderDetails({});
          let arr = [];
          if (value === 0) {
            arr = removeOrder(placedData.data, orderPk);
            setPlacedData({ ...placedData, data: [...arr] });
          }
          if (value === 1) {
            arr = removeOrder(approvedData.data, orderPk);
            setApprovedData({ ...approvedData, data: [...arr] });
          }
          if (value === 2) {
            arr = removeOrder(shippedData.data, orderPk);
            setShippedData({ ...shippedData, data: [...arr] });
          }
          if (value === 3) {
            arr = removeOrder(rejectedData.data, orderPk);
            setRejectedData({ ...rejectedData, data: [...arr] });
          }
          if (value === 4) {
            arr = removeOrder(archiveData.data, orderPk);
            setArchiveData({ ...archiveData, data: [...arr] });
          }
          emptyData(orderStatus);
          NotificationManager.success(res.Message, "", 3000);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onEdit = (orderPK) => {
    context.setBackDropOpen(true);
    instance
      .get(`api/v1/Order/editOrder?orderPk=${orderPK}`)
      .then((res) => {
        if (res.Is_Success) {
          context.setEditOrderJSON(res.data ?? {});
          context.setEditMode(true);
          navigate(routeConstant.LIST_EDIT_CREATE_ORDER, {
            state: { edit: true, editOrderJSON: res.data },
          });
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        context.setBackDropOpen(false);
      })
      .catch((err) => {
        console.error(err);
        if (err.response) {
          NotificationManager.error(err.response.data.Message, "", 3000);
        } else if (err.request) {
        } else if (err.message) {
        } else {
          NotificationManager.error("Something went wrong!", "", 3000);
        }
        context.setBackDropOpen(false);
      });
  };

  const onSearchKeyPress = (e) => {
    if (e.key === "Enter") {
      setPlacedData({ data: [], page: 0, hasMore: false });
      setApprovedData({ data: [], page: 0, hasMore: false });
      setShippedData({ data: [], page: 0, hasMore: false });
      setRejectedData({ data: [], page: 0, hasMore: false });
      setArchiveData({ data: [], page: 0, hasMore: false });
      setSearch(true);
      setLoading(true);
      setBuyerSelected({
        OrgCode: "",
        OrgName: "",
      });
      setOrderDetails({});
      setSearchCards({});
      const body = {
        SearchData: searchValue,
        OrgCodes: "",
        Status: "",
        SortColumnName: "OD_OrderLastEditedDateUTC",
        SortDirection: "DESC",
        CurrentPage: 0,
        PageSize: pageSize,
      };
      instance
        .post(`${path.SEARCH_ORDER}`, body)
        .then(async (res) => {
          if (res.Is_Success) {
            setSearchCards(res.data ?? {});
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          setSearchCards({});
          setLoading(false);
        });
    }
  };

  const getComments = (orderPk = orderDetails?.OrderHeader?.OrderPK) => {
    setCommentsList([]);
    setCommentsLoading(true);
    let contactName = oldContext.omsUserData?.FullName;
    let emailid = oldContext.omsUserData?.EmailId;
    const url = `${path.POST_COMMENT}?orederPk=${orderPk}&postdata=&contactname=${contactName}&emailid=${emailid}`;
    instance
      .post(url)
      .then(async (res) => {
        if (res.Is_Success) {
          await setCommentsList(res.data ?? []);
        } else {
          NotificationManager.error(res.Message, "", 3000);
        }
        setCommentsLoading(false);
      })
      .catch((err) => {
        console.error(err);
        // if (err.response) {
        //   if (err.response.data.Message != "Post is Not Present") {
        //     NotificationManager.error(err.response.data.Message, "", 3000);
        //   }
        // } else if (err.request) {
        // } else if (err.message) {
        // } else {
        //   NotificationManager.error("Something went wrong!", "", 3000);
        // }
        setCommentsLoading(false);
        setCommentsList([]);
      });
  };

  const onPostComment = () => {
    if (comment) {
      context.setBackDropOpen(true);
      let contactName = oldContext.omsUserData?.FullName;
      let emailid = oldContext.omsUserData?.EmailId;
      const url = `${path.POST_COMMENT}?orederPk=${orderDetails?.OrderHeader?.OrderPK}&postdata=${comment}&contactname=${contactName}&emailid=${emailid}`;
      instance
        .post(url)
        .then((res) => {
          if (res.Is_Success) {
            setCommentsList(res.data ?? []);
            NotificationManager.success(res.Message, "", 3000);
            setComment("");
          } else {
            NotificationManager.error(res.Message, "", 3000);
          }
          context.setBackDropOpen(false);
        })
        .catch((err) => {
          console.error(err);
          if (err.response) {
            NotificationManager.error(err.response.data.Message, "", 3000);
          } else if (err.request) {
          } else if (err.message) {
          } else {
            NotificationManager.error("Something went wrong!", "", 3000);
          }
          context.setBackDropOpen(false);
        });
    } else {
      NotificationManager.error("Please fill comments!", "", 3000);
    }
  };

  const onTabChange = (index) => {
    setValue(index);
    setOrderDetails({});
  };

  return (
    <>
      <div className="_orderList">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-7 col-12 _orderListCol">
              <div className="_orderSearchFilter">
                <div className="_orderSearch">
                  <SearchIcon />
                  <input
                    className="form-control"
                    placeholder="Search Orders"
                    type="text"
                    value={searchValue}
                    onChange={async (e) => {
                      if (!e.target.value) {
                        setSearch(false);
                        setPlacedData({ data: [], page: 0, hasMore: false });
                        setApprovedData({ data: [], page: 0, hasMore: false });
                        setShippedData({ data: [], page: 0, hasMore: false });
                        setRejectedData({ data: [], page: 0, hasMore: false });
                        setArchiveData({ data: [], page: 0, hasMore: false });
                        setOrderDetails({});
                      }
                      setSearchValue(e.target.value);
                    }}
                    onKeyPress={onSearchKeyPress}
                  />
                </div>
                {oldContext.omsUserData?.UserRoles.includes("Admin") ? (
                  <div className=" _orderSearchSelect">
                    <Autocomplete
                      disablePortal
                      disableClearable={buyerSelected?.OrgCode ? false : true}
                      size="small"
                      value={buyerSelected}
                      onChange={(event, newValue) => {
                        setPlacedData({ data: [], page: 0, hasMore: false });
                        setApprovedData({ data: [], page: 0, hasMore: false });
                        setShippedData({ data: [], page: 0, hasMore: false });
                        setRejectedData({ data: [], page: 0, hasMore: false });
                        setArchiveData({ data: [], page: 0, hasMore: false });
                        setBuyerSelected({
                          OrgCode: "",
                          OrgName: "",
                        });
                        if (!newValue) {
                          setBuyerSelected({
                            OrgCode: "",
                            OrgName: "",
                          });
                        } else {
                          setSearchValue("");
                          setSearch(false);
                          setBuyerSelected(newValue);
                        }
                      }}
                      options={buyerList ?? []}
                      getOptionLabel={(option) => option.OrgCode}
                      renderInput={(params) => (
                        <TextField {...params} label="Select Buyer" />
                      )}
                    />
                  </div>
                ) : null}
              </div>
              <div className="_orderListTabDiv">
                {search ? (
                  <TabContext value={0}>
                    <TabList
                      className="_searchTabButton"
                      onChange={(event, newValue) => {
                        setComment("");
                        setOrderDetails({});
                        setValue(0);
                      }}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor: "#438bc3",
                        },
                      }}
                    >
                      <Tab
                        className="_orderPlacedTab _orderSearchTab"
                        label="Search Result"
                      />
                    </TabList>
                    <TabPanel
                      className={`_orderListTabPanelDiv _orderListTabPanelDiv${0}`}
                      value={0}
                    >
                      {loading ? (
                        <Loading />
                      ) : Object.keys(searchCards).length === 0 ||
                        searchCards?.OrderHeader?.length === 0 ? (
                        <NoData>
                          <p>No order found!</p>
                        </NoData>
                      ) : (
                        searchCards?.OrderHeader?.map((ele, index) => {
                          return (
                            <div
                              className={
                                orderDetails?.OrderHeader?.OrderPK ===
                                  ele.OrderPK
                                  ? "_dashboardCardBody _activePlacedCard"
                                  : "_dashboardCardBody"
                              }
                              key={index}
                              onClick={() => orderDetailsCardClick(ele)}
                            >
                              <Card data={ele} onEdit={onEdit} />
                            </div>
                          );
                        })
                      )}
                    </TabPanel>
                  </TabContext>
                ) : (
                  <TabContext value={value}>
                    <TabList
                      variant="scrollable"
                      scrollButtons="auto"
                      onChange={(event, newValue) => {
                        // setCardData({});
                        setOrderDetails({});
                        setValue(newValue);
                      }}
                      TabIndicatorProps={{
                        style: {
                          backgroundColor:
                            value === 0
                              ? "#438bc3"
                              : value === 1
                                ? "#00e216"
                                : value === 2
                                  ? "#fa9130"
                                  : value === 3
                                    ? "#f01313"
                                    : value === 4
                                      ? "#6f42c1"
                                      : null,
                        },
                      }}
                    >
                      <Link
                        to={routeConstant.ORDER_LIST_PLACED}
                        onClick={() => {
                          onTabChange(0);
                        }}
                      >
                        <Tab className="_orderPlacedTab" label="Placed" />
                      </Link>
                      <Link
                        to={routeConstant.ORDER_LIST_APPROVED}
                        onClick={() => onTabChange(1)}
                      >
                        <Tab className="_orderApprovedTab" label="Approved" />
                      </Link>

                      <Link
                        to={routeConstant.ORDER_LIST_LOADED}
                        onClick={() => onTabChange(2)}
                      >
                        <Tab className="_orderLoadedTab" label="Loaded" />
                      </Link>
                      <Link
                        to={routeConstant.ORDER_LIST_REJECTED}
                        onClick={() => onTabChange(3)}
                      >
                        <Tab className="_orderRejectedTab" label="Cancelled" />
                      </Link>
                      <Link
                        to={routeConstant.ORDER_LIST_ARCHIVE}
                        onClick={() => onTabChange(4)}
                      >
                        <Tab className="_orderArchiveTab" label="Archived" />
                      </Link>
                    </TabList>
                    <Outlet
                      context={[
                        value,
                        orderDetailsCardClick,
                        buyerSelected.OrgCode,
                      ]}
                    />
                  </TabContext>
                )}
              </div>
            </div>
            <div className="col-md-5 col-12 _orderListDetailsDiv">
              {Object.keys(orderDetails).length ? (
                <div className="_orderListDetails">
                  <>
                    <div className="_orderNumberStatus">
                      <p
                        title={
                          orderDetails?.OrderHeader?.SplitNumber == "0"
                            ? `${orderDetails?.OrderHeader?.OrderNumber}`
                            : `${orderDetails?.OrderHeader?.OrderNumber}/${orderDetails?.OrderHeader?.SplitNumber}`
                        }
                      >
                        {orderDetails?.OrderHeader?.OrderNumber ?? "N/A"}
                        {orderDetails?.OrderHeader?.SplitNumber !== "0"
                          ? `/${orderDetails?.OrderHeader?.SplitNumber}`
                          : ""}
                      </p>
                      <div className="_orderListDetailsAction">
                        <div className="dropdown">
                          <button
                            className="btn btn-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            Change Status
                          </button>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            <li
                              className={`dropdown-item 
                                  ${orderDetails?.OrderHeader?.OrderStatus ===
                                  "PLC"
                                  ? "active"
                                  : ""
                                }`}
                              onClick={() => {
                                let isPlanSelected =
                                  orderDetails?.OrderPlanningCollection?.some(
                                    (element) => element.IsFreezed
                                  );
                                if (
                                  isPlanSelected &&
                                  orderDetails?.OrderHeader?.OrderStatus ===
                                  "SHP" &&
                                  !context.orderUserAccess?.StatusChangeSHPPLC
                                ) {
                                  NotificationManager.error(
                                    "You don't have the permission. Please contact to admin.",
                                    "",
                                    3000
                                  );
                                } else {
                                  onOrderStatusChange(
                                    orderDetails?.OrderHeader?.OrderPK,
                                    "PLC"
                                  );
                                }
                              }}
                            >
                              Placed
                            </li>
                            {context.orderUserAccess?.StatusChangeApp && (
                              <li
                                className={`dropdown-item  
                                    ${orderDetails?.OrderHeader?.OrderStatus ===
                                    "APP"
                                    ? "active"
                                    : ""
                                  }`}
                                onClick={() => {
                                  let isPlanSelected =
                                    orderDetails?.OrderPlanningCollection?.some(
                                      (element) => element.IsFreezed
                                    );
                                  if (
                                    isPlanSelected &&
                                    orderDetails?.OrderHeader?.OrderStatus ===
                                    "SHP" &&
                                    !context.orderUserAccess?.StatusChangeSHPPLC
                                  ) {
                                    NotificationManager.error(
                                      "You don't have the permission. Please contact to admin.",
                                      "",
                                      3000
                                    );
                                  } else {
                                    onOrderStatusChange(
                                      orderDetails?.OrderHeader?.OrderPK,
                                      "APP"
                                    );
                                  }
                                }}
                              >
                                Approved
                              </li>
                            )}
                            {context.orderUserAccess?.StatusChangeSHP && (
                              <li
                                className={`dropdown-item  
                                    ${orderDetails?.OrderHeader?.OrderStatus ===
                                    "SHP"
                                    ? "active"
                                    : ""
                                  }`}
                                onClick={() => {
                                  let isPlanSelected =
                                    orderDetails?.OrderPlanningCollection?.some(
                                      (element) => element.IsFreezed
                                    );
                                  if (
                                    isPlanSelected &&
                                    orderDetails?.OrderHeader?.OrderStatus ===
                                    "SHP" &&
                                    !context.orderUserAccess?.StatusChangeSHPPLC
                                  ) {
                                    NotificationManager.error(
                                      "You don't have the permission. Please contact to admin.",
                                      "",
                                      3000
                                    );
                                  } else {
                                    onOrderStatusChange(
                                      orderDetails?.OrderHeader?.OrderPK,
                                      "SHP"
                                    );
                                  }
                                }}
                              >
                                Loaded
                              </li>
                            )}
                            {context.orderUserAccess?.StatusChangeCAN && (
                              <li
                                className={`dropdown-item  
                                    ${orderDetails?.OrderHeader?.OrderStatus ===
                                    "CAN"
                                    ? "active"
                                    : ""
                                  }`}
                                onClick={() => {
                                  let isPlanSelected =
                                    orderDetails?.OrderPlanningCollection?.some(
                                      (element) => element.IsFreezed
                                    );
                                  if (
                                    isPlanSelected &&
                                    orderDetails?.OrderHeader?.OrderStatus ===
                                    "SHP" &&
                                    !context.orderUserAccess?.StatusChangeSHPPLC
                                  ) {
                                    NotificationManager.error(
                                      "You don't have the permission. Please contact to admin.",
                                      "",
                                      3000
                                    );
                                  } else {
                                    onOrderStatusChange(
                                      orderDetails?.OrderHeader?.OrderPK,
                                      "CAN"
                                    );
                                  }
                                }}
                              >
                                Cancelled
                              </li>
                            )}
                            {context.orderUserAccess?.StatusChangeARC && (
                              <li
                                className={`dropdown-item  
                                    ${orderDetails?.OrderHeader?.OrderStatus ===
                                    "ARC"
                                    ? "active"
                                    : ""
                                  }`}
                                onClick={() => {
                                  let isPlanSelected =
                                    orderDetails?.OrderPlanningCollection?.some(
                                      (element) => element.IsFreezed
                                    );
                                  if (
                                    isPlanSelected &&
                                    orderDetails?.OrderHeader?.OrderStatus ===
                                    "SHP" &&
                                    !context.orderUserAccess?.StatusChangeSHPPLC
                                  ) {
                                    NotificationManager.error(
                                      "You don't have the permission. Please contact to admin.",
                                      "",
                                      3000
                                    );
                                  } else {
                                    onOrderStatusChange(
                                      orderDetails?.OrderHeader?.OrderPK,
                                      "ARC"
                                    );
                                  }
                                }}
                              >
                                Archived
                              </li>
                            )}
                          </ul>
                        </div>
                        {/* <select
                          className="form-select"
                          value={orderDetails?.OrderHeader?.OrderStatus}
                          onChange={(e) => {
                            let isPlanSelected =
                              orderDetails?.OrderPlanningCollection?.some(
                                (element) => element.IsFreezed
                              );
                            if (
                              isPlanSelected &&
                              orderDetails?.OrderHeader?.OrderStatus ===
                                "SHP" &&
                               isPlanSelected &&
                              orderDetails?.OrderHeader?.OrderStatus ===
                                "SHP" &&
                              !context.orderUserAccess?.StatusChangeSHPPLC
                            ) {
                              NotificationManager.error(
                                "You don't have the permission. Please contact to admin.",
                                "",
                                3000
                              );
                            } else {
                              onOrderStatusChange(
                                orderDetails?.OrderHeader?.OrderPK,
                                e.target.value
                              );
                            }
                          }}
                        >
                          <option value={"PLC"}>Placed</option>

                          {context.orderUserAccess?.StatusChangeApp ? (
                            <option value={"APP"}>Approved</option>
                          ) : (
                            ""
                          )}
                          {context.orderUserAccess?.StatusChangeSHP ? (
                            <option value={"SHP"}>Loaded</option>
                          ) : (
                            ""
                          )}
                          {context.orderUserAccess?.StatusChangeCAN ? (
                            <option value={"CAN"}>Cancelled</option>
                          ) : (
                            ""
                          )}
                          {context.orderUserAccess?.StatusChangeARC ? (
                            <option value={"ARC"}>Archived</option>
                          ) : (
                            ""
                          )}
                        </select> */}
                      </div>
                    </div>
                    <div className="_orderMapMilestone">
                      <div className="_orderListMilestone">
                        <div className="_orderTimelineDivParent">
                          {orderDetails.OrderMilstonesCollection.map(
                            (ele, index) => {
                              let length =
                                orderDetails?.OrderMilstonesCollection.length;
                              return (
                                <div className="_orderTimelineDiv" key={index}>
                                  <div className="_orderTimelineDotLine">
                                    <div className="_orderTimelineDot "></div>
                                    {index + 0 < length ? (
                                      <div className="_orderTimelineLine"></div>
                                    ) : null}
                                  </div>
                                  <div className="_orderTimelineInputs">
                                    <h6>{ele.MilstoneDescription}</h6>
                                    <table>
                                      <tbody>
                                        <tr>
                                          <td>Est. Date</td>
                                          <td>:</td>
                                          <td>
                                            {ele.MilstoneEstimatedDate
                                              ? moment(
                                                ele.MilstoneEstimatedDate
                                              ).format("MM/DD/YYYY")
                                              : ""}
                                          </td>
                                        </tr>
                                        <tr>
                                          <td>Act. Date</td>
                                          <td>:</td>
                                          <td>
                                            {ele.MilstoneActualDate
                                              ? moment(
                                                ele.MilstoneActualDate
                                              ).format("MM/DD/YYYY")
                                              : ""}
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>

                                </div>
                              );
                            }
                          )}


                          <div class="_orderTimelineDiv">
                            <div class="_orderTimelineDotLine">
                              <div class="_orderTimelineDot "></div>
                              {/* <div class="_orderTimelineLine"></div> */}
                            </div>
                            <div class="_orderTimelineInputs">
                              <h6>Pickup from Origin Factory</h6>
                              <table>
                                <tbody>
                                  
                                  <tr>
                                    <td>Act. Date</td>
                                    <td>:</td>
                                    <td>
                                    {orderDetails.OrderHeader.PickupfromOriginFactory
                             ===
                          "1900/01/01 00:00:00.000"
                            ? ""
                            : orderDetails.OrderHeader
                                .PickupfromOriginFactory
                            ? moment(
                              orderDetails.OrderHeader
                                  .PickupfromOriginFactory
                              ).format("MM/DD/YYYY")
                            : ""}
                       
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </div>

                      </div>
                    </div>
                    {orderDetails?.OrderHeader?.OrderSpecialInstruction ? (
                      <div className="_orderSpecialInst">
                        <h6>Special Instructions</h6>
                        <p>
                          {orderDetails?.OrderHeader?.OrderSpecialInstruction}
                        </p>
                      </div>
                    ) : null}

                    <div className="_orderComment">
                      <h6>Comments</h6>
                      <div className="_orderCommentsDivParent">
                        {commentsLoading ? (
                          <Loading />
                        ) : !commentsList.length ? (
                          <NoData>No comments found</NoData>
                        ) : (
                          commentsList.map((ele, index) => {
                            return (
                              <div className="_orderCommentDiv" key={index}>
                                <h6>{ele.PostedUser}</h6>
                                <div>
                                  <span title="title">{ele.PostedEmail}</span>
                                  <span>
                                    {moment(ele.CommentDate).format(
                                      "MM-DD-YYYY hh:mm:ss A"
                                    )}
                                  </span>
                                </div>
                                <p>{ele.CommentData ?? ""}</p>
                              </div>
                            );
                          })
                        )}
                      </div>
                      <div className="_orderPostComments">
                        <textarea
                          // rows={1}
                          placeholder="Post Comments"
                          className="form-control"
                          value={comment}
                          onKeyPress={(e) => {
                            if (e.key === "Enter" && !e.shiftKey) {
                              onPostComment();
                            }
                          }}
                          onChange={(e) => setComment(e.target.value)}
                        />
                        <button onClick={onPostComment}>Post</button>
                      </div>
                    </div>
                    <div className="_orderViewFullDetails">
                      <p
                        onClick={() =>
                          navigate(routeConstant.ORDER_LIST_FULL, {
                            state: orderDetails,
                          })
                        }
                      >
                        View Full Details <ArrowForwardIosIcon />
                      </p>
                    </div>
                  </>
                </div>
              ) : (
                <div className="_orderListClickShowDiv">
                  <p>Click on an Order to know details</p>
                  <AddOrder_svg />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <FilterModal getSystemLogg={() => { }} />
    </>
  );
}

export default OrderList;
